import { Exclude, Expose, Type } from 'class-transformer';

@Exclude()
export class FlockModel {
  @Expose()
  breedFlockCode?: string | null;

  @Expose()
  breederId?: number | null;

  @Expose()
  flockCode?: string | null;

  @Expose()
  breedId?: string | null;

  @Expose()
  breedTitle?: string | null;

  @Expose()
  species?: string | null;

  @Expose()
  flockVisibility?: number;

  @Expose()
  flockGrpName?: string | null;

  @Expose()
  description?: string | null;

  @Expose()
  latestDrop?: number;

  @Expose()
  group?: string | null;

  @Expose()
  userIndexCode?: string | null;

  @Expose()
  webListing?: string | null;

  @Expose()
  @Type(() => Date)
  renewalStart?: Date | null;

  @Expose()
  @Type(() => Date)
  renewalEnd?: Date | null;

  @Expose()
  status?: string | null;

  @Expose()
  type?: string | null;

  @Expose()
  showAnimals?: boolean;

  @Expose()
  showContacts?: boolean;
}

@Exclude()
export class FlockDetailModel {
  @Expose()
  @Type(() => FlockModel)
  flock?: FlockModel | null;

  @Expose()
  companyId?: number | null;

  @Expose()
  website?: string | null;

  @Expose()
  pics?: string[] | null;

  @Expose()
  @Type(() => FlockUserModel)
  users?: FlockUserModel[] | null;
}

@Exclude()
export class FlockUserModel {
  @Expose()
  flockCode?: string | null;

  @Expose()
  role?: number | null;

  @Expose()
  userId?: number | null;

  @Expose()
  firstName?: string | null;

  @Expose()
  lastName?: string | null;

  @Expose()
  email?: string | null;
}

@Exclude()
export class FlockEditModel {
  @Expose()
  breedFlockCode?: string | null;

  @Expose()
  flockCode?: string | null;

  @Expose()
  breedId?: string | null;

  @Expose()
  species?: string | null;

  @Expose()
  description?: string | null;

  @Expose()
  status?: string | null;

  @Expose()
  flockVisibility?: number;

  @Expose()
  showAnimals?: boolean;

  @Expose()
  showContacts?: boolean;

  @Expose()
  companyId?: number | null;

  @Expose()
  website?: string | null;

  @Expose()
  group?: string | null;

  @Expose()
  userIndexCode?: string | null;

  @Expose()
  type?: string | null;

  @Expose()
  billingType?: string | null;

  @Expose()
  pics?: string[] | null;
}

@Exclude()
export class BreedModel {
  @Expose()
  id: string;

  @Expose()
  title: string;

  @Expose()
  species: string;
}

@Exclude()
export class FlockListingModel {
  @Expose()
  breedFlockCode: string;

  @Expose()
  flockName: string;

  @Expose()
  species: string;

  @Expose()
  breed: string;

  @Expose()
  status: number;

  @Expose()
  pic?: string | null;
}

@Exclude()
export class FlockGroupModel {
  @Expose()
  id: number;

  @Expose()
  groupCode?: string | null;

  @Expose()
  groupName?: string | null;

  @Expose()
  description?: string | null;

  @Expose()
  analysis?: string | null;
}

@Exclude()
export class FlockUserIndexModel {
  @Expose()
  userIndexCode?: string | null;

  @Expose()
  name?: string | null;

  @Expose()
  formula?: string | null;

  @Expose()
  note?: string | null;

  @Expose()
  allBreed?: string | null;

  @Expose()
  @Type(() => Date)
  createDate?: Date | null;

  @Expose()
  @Type(() => Date)
  modifyDate?: Date | null;

  @Expose()
  status?: boolean | null;
}

@Exclude()
export class FlockProfileTestListModel {
  @Expose()
  id: number;

  @Expose()
  analysisType: string;

  @Expose()
  analysisDate: string;

  @Expose()
  orderId: string;

  @Expose()
  companyName: string;

  @Expose()
  ownerCompanyId?: number | null;

  @Expose()
  genomicCompanyId?: number | null;

  @Expose()
  genomicCompanyCode?: string | null;

  @Expose()
  genomicCompanyName?: string | null;

  @Expose()
  dropYearLabel?: string | null;
}

@Exclude()
export class FlockProfileGenomicProviderModel {
  @Expose()
  companyId: number;

  @Expose()
  companyCode: string;

  @Expose()
  companyName: string;
}

@Exclude()
export class FlockProfileOrderClaimRequest {
  @Expose()
  genomicProviderCompanyCode: string;

  @Expose()
  orderCode: string;

  @Expose()
  email: string;
}

@Exclude()
export class FlockProfileOrderClaimResult {
  @Expose()
  id: number;

  @Expose()
  orderId: string;

  @Expose()
  orderCode?: string | null;

  @Expose()
  ownerCompanyId: number;

  @Expose()
  companyName: string;

  @Expose()
  genomicCompanyId?: number | null;

  @Expose()
  genomicCompanyCode?: string | null;

  @Expose()
  genomicCompanyName?: string | null;

  @Expose()
  analysisType: string;

  @Expose()
  analysisDate: string;

  @Expose()
  dropYearLabel?: string | null;
}

@Exclude()
export class FlockProfileTestResultModel {
  @Expose()
  traitId?: number | null;

  @Expose()
  traitAnalysisId?: number | null;

  @Expose()
  trait_analysis_id?: number | null;

  @Expose()
  traitAnalysisID?: number | null;

  @Expose()
  selectedByDefault?: boolean | null;

  @Expose()
  isDefaultTrait?: boolean | null;

  @Expose()
  defaultTrait?: boolean | null;

  @Expose()
  selected_by_default?: boolean | null;

  @Expose()
  is_default_trait?: boolean | null;

  @Expose()
  value: number;

  @Expose()
  rank: number;

  @Expose()
  accuracy: string;

  @Expose()
  accuracyLabel: string;

  @Expose()
  traitCode: string;

  @Expose()
  traitName: string;

  @Expose()
  traitGroup: string;

  @Expose()
  traitGroupColour: string;

  @Expose()
  rankLowLabel: string;

  @Expose()
  rankHighLabel: string;
}

@Exclude()
export class FlockProfileTestModel {
  @Expose()
  analysisId?: number | null;

  @Expose()
  breedFlockCode: string;

  @Expose()
  breedFlockName: string;

  @Expose()
  testType: string;

  @Expose()
  orderId: string;

  @Expose()
  orderedByCompanyId?: number | null;

  @Expose()
  ownerCompanyId?: number | null;

  @Expose()
  genomicCompanyId?: number | null;

  @Expose()
  companyName?: string | null;

  @Expose()
  genomicCompanyCode?: string | null;

  @Expose()
  genomicCompanyName?: string | null;

  @Expose()
  analysisType: string;

  @Expose()
  analysisDate: string;

  @Expose()
  dropYearLabel?: string | null;

  @Expose()
  @Type(() => FlockProfileTestResultModel)
  results: FlockProfileTestResultModel[] = [];
}

@Exclude()
export class FlockProfileScenarioModel {
  @Expose()
  scenarioId: number;

  @Expose()
  analysisId: number;

  @Expose()
  scenario: string;

  @Expose()
  indexId?: number | null;

  @Expose()
  indexAbbrev?: string | null;

  @Expose()
  indexTraitName?: string | null;
}

@Exclude()
export class FlockProfileDefaultTraitModel {
  @Expose()
  displayOrder: number;

  @Expose()
  traitId: number;

  @Expose()
  traitAnalysisId?: number | null;

  @Expose()
  abbrev: string;

  @Expose()
  traitName: string;
}

@Exclude()
export class MoveFlockRequest {
  @Expose()
  sourceCompanyId: number;

  @Expose()
  destinationCompanyId: number;

  @Expose()
  breedFlockCode: string;
}
